import { render, staticRenderFns } from "./UserFieldBuilder.vue?vue&type=template&id=f915b4fa&scoped=true&"
import script from "./UserFieldBuilder.vue?vue&type=script&lang=js&"
export * from "./UserFieldBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f915b4fa",
  null
  
)

export default component.exports